import React from 'react';
import { Box, CircularProgress, Container } from '@mui/material';



export default function Loading({ headerText = 'Preparing Calculator...' }) {

    return (
        <Container fixed sx={{ height: 600 }}>
            <Box
                className='beacon-theme-modern-outlook'
                sx={{
                    height: '100%',
                    width: '100%',
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                }}

            >
                <Box className='b-typography-sans-serif--body-loose--200' pb='16px'>
                    {headerText}
                </Box>
                <CircularProgress
                    sx={{
                        animation: 'none',
                        strokeDasharray: '80px, 200px',
                        strokeDashoffset: '0px',
                        color: '#05C3DE' 
                    }}
                    size={200}
                    thickness={1}
                    alt='loading'
                    id='loading-spinner'
                    aria-label='loading-spinner'
                />
            </Box>
        </Container>
    );
}
